import Vue from 'vue'
import Vuex from 'vuex'
import userModule from './module/userModule'

Vue.use(Vuex)

export default new Vuex.Store({
    modules: {
        userModule
    }
})


// WEBPACK FOOTER //
// ./src/store/index.js